export const useDynamicTranslation = () => {
  const localeStore = useLocaleStore()
  const { selectedLanguage } = storeToRefs(localeStore)

  const { t, loadLocaleMessages } = useI18n({ useScope: 'global' })

  const translate = async (key: string) => {
    const languageCode = selectedLanguage.value

    if (!languageCode) {
      return t(key) ?? key
    }

    await loadLocaleMessages(languageCode)

    return t(key, 1, { locale: languageCode }) ?? key
  }

  return {
    translate
  }
}
